import auth, { AuthParams } from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';

export type IRoute = AuthParams & {
  name: string;
  key: string;
  // 当前页是否展示面包屑
  breadcrumb?: boolean;
  children?: IRoute[];
  // 当前路由是否渲染菜单项，为 true 的话不会在菜单中显示，但可通过路由地址访问。
  ignore?: boolean;
};

export const routes: IRoute[] = [
  {
    name: '项目评估',
    key: 'project',
    requiredPermissions: [],
    children: [],
  },
  {
    name: '设备询价',
    key: 'inquiry/projectQuickly/create',
    requiredPermissions: [],
  },
  {
    name: '上传文件',
    key: 'projectUpload',
    ignore: true,
    requiredPermissions: [],
  },
  {
    name: '评估结果',
    key: 'projectDetail',
    ignore: true,
    requiredPermissions: [],
  },
  {
    name: '账单',
    key: 'finance',
    requiredPermissions: [],
  },
  {
    name: '造价标准',
    key: 'parameter',
    requiredPermissions: [],
  },
  {
    name: '行业数据',
    key: 'charts',
    requiredPermissions: [],
  },
  {
    name: '专家对接',
    key: 'expert',
    requiredPermissions: [],
  },
  {
    name: '操作手册',
    key: 'help',
    requiredPermissions: [],
  },
  {
    name: '演示视频',
    key: 'helpVideo',
    requiredPermissions: [],
  },
  {
    name: '常见问题',
    key: 'question',
    requiredPermissions: [],
  },
  {
    name: '联系客服',
    key: 'service',
    requiredPermissions: [],
  },
  {
    name: '创建项目',
    key: 'inquiry/project/create',
    ignore: true,
    requiredPermissions: [],
  },
  {
    name: '项目详情',
    key: 'inquiry/project/detail',
    ignore: true,
    requiredPermissions: [],
  },
  {
    name: '申请评审',
    ignore: true,
    key: 'projectExpertReview',
    requiredPermissions: [],
  },
  // {
  //   name: '设备询价',
  //   key: 'inquiry/projectQuickly/create',
  //   ignore: true,
  //   requiredPermissions: [],
  // },
  {
    name: '设备询价详情',
    key: 'inquiry/projectQuickly/detail',
    ignore: true,
    requiredPermissions: [],
  },
];

export const getName = (path: string, routes) => {
  return routes.find((item) => {
    const itemPath = `/${item.key}`;
    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};

export const generatePermission = (role: string) => {
  const actions = role === 'admin' ? ['*'] : ['read'];
  const result = {};
  routes.forEach((item) => {
    if (item.children) {
      item.children.forEach((child) => {
        result[child.name] = actions;
      });
    }
  });
  return result;
};

const useRoute = (userPermission): [IRoute[], string] => {
  const filterRoute = (routes: IRoute[], arr = []): IRoute[] => {
    if (!routes.length) {
      return [];
    }
    for (const route of routes) {
      const { requiredPermissions, oneOfPerm } = route;
      let visible = true;
      if (requiredPermissions) {
        visible = auth({ requiredPermissions, oneOfPerm }, userPermission);
      }

      if (!visible) {
        continue;
      }
      if (route.children && route.children.length) {
        const newRoute = { ...route, children: [] };
        filterRoute(route.children, newRoute.children);
        if (newRoute.children.length) {
          arr.push(newRoute);
        }
      } else {
        arr.push({ ...route });
      }
    }

    return arr;
  };

  const [permissionRoute, setPermissionRoute] = useState(routes);

  useEffect(() => {
    const newRoutes = filterRoute(routes);
    setPermissionRoute(newRoutes);
  }, [JSON.stringify(userPermission)]);

  const defaultRoute = useMemo(() => {
    // 检查是否带了channelId
    const params = new URLSearchParams(window.location.search);
    // console.warn(window.location);
    const channelId = params.get('channelId');
    if (channelId) {
      window.localStorage.setItem('channelId', channelId);
    }

    const first = permissionRoute[0];
    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key;
      return firstRoute;
    }
    return '';
  }, [permissionRoute]);

  return [permissionRoute, defaultRoute];
};

export default useRoute;
